export enum UserRole {
  User = 'User', // empty role
  Administrator = 'Administrator',
  SalesRepresentative = 'SalesRepresentative',
  System = 'System',
  ReportsUser = 'ReportsUser',
  AssortmentsUser = 'AssortmentsUser',
  SmuUser = 'SmuUser',
  Buyer = 'Buyer',
  Merchandiser = 'Merchandiser',
  CustomerService = 'CustomerService',
}
